import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * "כיתות" — list of grades + their active-student count. Each row links
 * to /grades/:id so an admin can jump straight into the grade's page.
 */
import React from 'react';
import { Empty, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { LeftOutlined } from '@ant-design/icons';
import { CardShell } from './CardShell';
import { PALETTE } from './helpers';
const { Text } = Typography;
export function GradesCard({ data, loading, error, onReload }) {
    const grades = data?.grades ?? [];
    return (_jsx(CardShell, { title: "\u05DB\u05D9\u05EA\u05D5\u05EA", loading: loading && grades.length === 0, error: error, onReload: onReload, skeletonRows: 4, bodyStyle: { padding: 8 }, children: grades.length === 0 ? (_jsx(Empty, { description: "\u05D0\u05D9\u05DF \u05DB\u05D9\u05EA\u05D5\u05EA \u05E2\u05D3\u05D9\u05D9\u05DF", image: Empty.PRESENTED_IMAGE_SIMPLE })) : (_jsx("ul", { style: { listStyle: 'none', margin: 0, padding: 0 }, children: grades.map((g) => (_jsx("li", { children: _jsxs(Link, { to: `/grades/${g.id}`, style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: 10,
                        padding: '10px 12px',
                        borderRadius: 10,
                        color: PALETTE.ink,
                        textDecoration: 'none',
                    }, className: "dash-row", children: [_jsx(Text, { style: { flex: 1, fontWeight: 500, color: PALETTE.ink }, children: g.name }), _jsxs("span", { className: "chip-lavender", children: [g.students.toLocaleString('he-IL'), " \u05EA\u05DC\u05DE\u05D9\u05D3\u05D9\u05DD"] }), _jsx(LeftOutlined, { style: { color: PALETTE.inkMuted, fontSize: 12 } })] }) }, g.id))) })) }));
}
